import {useRegDocTranslations} from '../hooks/RegulatoryDocuments.commonHooks';

export const useRegDocDetailsPageTranslations = () => {
	return useRegDocTranslations({
		keyPrefix: 'RegulatoryDocumentDetailsPage',
	});
};
